import { useId } from "react";
import { NoktaTuru } from "@kantin/shared";
import { Secim } from "@kantin/ui";
import type { Nokta } from "./kancalar.js";

export function nakitNoktasiUygunMu(nokta: Nokta) {
  return nokta.aktif && nokta.tur !== NoktaTuru.KANTIN;
}

export function NakitNoktasiSecimi({
  noktalar,
  deger,
  degistir,
  hata,
}: {
  noktalar: Nokta[];
  deger: string;
  degistir: (deger: string) => void;
  hata?: string | undefined;
}) {
  const aciklamaId = useId();
  const hataId = useId();
  const uygunNoktalar = noktalar.filter(nakitNoktasiUygunMu);
  const aciklama =
    "Yalnızca kantin olmayan aktif noktalar seçilebilir. Noktalar ekranından kantin dışında bir tür seçerek “Muhasebe” adında bir nokta eklerseniz burada Muhasebe’yi seçebilirsiniz.";

  if (uygunNoktalar.length === 0) {
    return (
      <p className="m-0 text-sm text-murekkep-3">
        Nakit tahsilat için seçilebilecek nokta bulunmuyor. {aciklama}
      </p>
    );
  }

  return (
    <div className="flex flex-col gap-1.5">
      <Secim
        etiket="Nakit hangi noktada alındı"
        value={uygunNoktalar.some((n) => n.id === deger) ? deger : ""}
        onChange={(e) => degistir(e.target.value)}
        secenekler={[
          { deger: "", metin: "Seçiniz" },
          ...uygunNoktalar.map((n) => ({ deger: n.id, metin: n.ad })),
        ]}
        aria-describedby={hata ? `${aciklamaId} ${hataId}` : aciklamaId}
        aria-invalid={!!hata}
      />
      <p id={aciklamaId} className="m-0 text-xs text-murekkep-3">
        {aciklama}
      </p>
      {hata && (
        <p id={hataId} className="m-0 text-xs text-hata">{hata}</p>
      )}
    </div>
  );
}
